<template>
  <Top5AccessToBikesCard />
</template>

<script>
import Top5AccessToBikesCard from '@/components/top5AccessToBikesCard.vue';

export default {
  components: {
    Top5AccessToBikesCard,
  },
};
</script>

<style lang="scss" scoped></style>
